import React from 'react';
import { Button } from './ui/Button';
import { TextReveal } from './ui/Reveal';
const STEPS = ['Onboard in under a day', 'Direction — first designs in 4–5 days', 'Design & build in 2–4 week sprints', 'Launch, hand over the files, and support'];
export function Process() {
  return <section id="process" className="w-full bg-black px-5 py-20 lg:px-8 lg:py-[157px]" data-id="element-153" data-mp="23etgxsqxx8l7">
      <div className="mx-auto flex w-full max-w-shell flex-col gap-10" data-id="element-154" data-mp="16oty95h2stow">
        <h2 className="max-w-[789px] text-3xl font-semibold leading-tight text-[#E3E3E3] lg:text-[40px] lg:leading-[48.8px]" data-id="element-155" data-mp="1apm9u5df7aoc">
          <TextReveal data-id="element-156" data-mp="1foh0fthmq3j0">We deliver on time, in days and weeks</TextReveal>
          <br className="hidden sm:block" data-id="element-157" data-mp="1kffkn45qnlrj" />
          <TextReveal data-id="element-158" data-mp="1kg7h0h75tniv">—not months.</TextReveal>
        </h2>

        <div className="flex flex-col justify-between gap-10 lg:flex-row" data-id="element-159" data-mp="n0bfb5mnycin">
          <ol className="flex w-full max-w-[626px] flex-col gap-3" data-id="element-160" data-mp="mxyy4uoqc66n">
            {STEPS.map((step, index) => <li key={step} className="flex items-center gap-[18px] rounded-full bg-[#212121] px-8 py-4" data-id="element-161" data-mp="19l7uuckof0mc" data-mpi={index}>
                <span className="text-base font-medium text-[#6F6F6F]" data-id="element-162" data-mp="15kxhgeuk17xg">
                  {index + 1}
                </span>
                <span className="text-base font-medium text-[#ECECEC]" data-id="element-163" data-mp="10qt4neyly5og">
                  {step}
                </span>
              </li>)}
          </ol>

          <div className="flex w-full max-w-[340px] flex-col items-start gap-6 lg:items-end lg:text-right" data-id="element-164" data-mp="qvj5cyzlgced">
            <p className="text-base font-medium leading-7 text-[#E3E3E3]" data-id="element-165" data-mp="lu3jj4ple1ux">
              Focused sprints with real feedback loops until it's genuinely
              right — then we ship, hand over the files, and stick around for
              what comes after.
            </p>
            <Button to="/#contact" variant="solid" data-id="element-166" data-mp="2c71cnvwt697i">
              Start Project
            </Button>
          </div>
        </div>
      </div>
    </section>;
}